import HttpClient from "./HttpClient";

export default class OrderSupplier {
    constructor(supplier) {
        this.id = supplier.id;
        this.ordered_at = supplier.ordered_at;
        this.order_number = supplier.order_number;
        this.confirmed_delivery_date = supplier.confirmed_delivery_date;
        this.comment = supplier.comment;
        this.status = supplier.status;
        this.order_id = supplier.order_id;
        this.supplier_id = supplier.supplier_id;
        this.created_at = supplier.created_at;
        this.updated_at = supplier.updated_at;
    }

    async save() {
        const client = new HttpClient();
        const response = await client.instance.put(`order-suppliers/${this.id}`, this);
        return response.data;
    }

    async clearDate(){
        this.confirmed_delivery_date = null;
        await this.save();
    }
}